import { BodyCell } from '@tableau/data-grid-1-wrapper';
import React from 'react';

import { highlightSearch } from './searchUtils';

export function highlightSearchTextCellFormatter(searchText: string): React.Factory<any> {
  return React.createFactory((props: BodyCell.Props): JSX.Element => <>{highlightSearch(props.value, searchText)}</>);
}
